export const rehydrateAction = (data: any) => ({
  type: 'REHYDRATE',
  data: data,
});
